import { useState } from 'react'
import { Button, Input } from 'antd'
import { appApi } from '../../api/app.api'
import './Login.scss'

function Login({ onLogin }) {
  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!token.trim()) return

    setLoading(true)
    setError('')

    try {
      const response = await appApi.login(token.trim())
      localStorage.setItem('auth_token', response.data.token)
      onLogin()
    } catch {
      setError('Invalid access token')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleSubmit}>
        <h2 className="login-title">Holly molly</h2>
        <Input.Password
          className="login-input"
          autoComplete="off"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          autoFocus
        />
        {error && <p className="login-error">{error}</p>}
        <Button
          className="login-button"
          type="primary"
          htmlType="submit"
          loading={loading}
          block
        >
          Access
        </Button>
      </form>
    </div>
  )
}

export default Login
